import React from "react";
import "./App.css";

export default function CzDialog({
  open,
  title,
  message,
  variant = "info", // "info" | "warning" | "danger"
  confirmText = "OK",
  cancelText = "Annulla",
  showCancel = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div className="cz-modal-backdrop">
      <div className={`cz-modal cz-modal--${variant}`}>
        {title ? <h3 className="cz-modal-title">{title}</h3> : null}
        <p className="cz-modal-message">{message}</p>

        <div className="cz-modal-actions">
          {showCancel && (
            <button className="cz-btn cz-btn-primary" onClick={onCancel}>
              {cancelText}
            </button>
          )}
          <button
            className={`cz-btn ${variant === "danger" ? "cz-btn-danger" : "cz-btn-primary"}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
